module.exports = __webpack_public_path__ + "img/long-bendy-arrow-right.a20dc289.svg";